import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';

import { createPragaDoenca, updatePragaDoenca } from '../service';
import {
  CREATE_PRAGA_DOENCA,
  CREATE_PRAGA_DOENCA_PENDING,
  CREATE_PRAGA_DOENCA_SUCCESS,
  CREATE_PRAGA_DOENCA_FAILURE
} from '../actionTypes';

import { AlertSuccess, AlertError } from '@components/common/AlertToast';
import { trackingEventCX } from '@handler/tracking/customerX/trackingEvent';
import { MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX/moduleActionEnum';

function* sagaCreatePragaDoenca(action) {
  yield put({ type: CREATE_PRAGA_DOENCA_PENDING })

  try {
    let registro = null

    if (action.data.id === undefined || action.data.id === null) {
      registro = yield call(createPragaDoenca, action.data)
      trackingEventCX('action', MODULE_ACTIONS_ENUM.PRAGA_DOENCA_CRIAR);
      AlertSuccess('Cadastro realizado com sucesso!')
    } else {
      registro = yield call(updatePragaDoenca, action.data)
      trackingEventCX('action', MODULE_ACTIONS_ENUM.PRAGA_DOENCA_EDITAR);
      AlertSuccess('Alteração realizada com sucesso!')
    }

    yield put({ type: CREATE_PRAGA_DOENCA_SUCCESS, registro: registro })

    if(!action.isCadastroRapido){
      history.push('/pragas-doencas');
    }

  } catch (error) {

    yield put({ type: CREATE_PRAGA_DOENCA_FAILURE })
    AlertError('Falha ao salvar o registro! Tente novamente...');
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchCreatePragaDoenca() {
  yield takeLatest(CREATE_PRAGA_DOENCA, sagaCreatePragaDoenca)
}